import { BrowserRouter, Route, Switch } from "react-router-dom";
import './App.css';
import Header from "./components/Header";
import SimpleBottomNavigation from "./components/bottom_nav"
import { Container } from "@material-ui/core";
import Trending from "./Pages/Trending";
import Movies from "./Pages/Movies";
import Series from "./Pages/Series";
import Search from "./Pages/Search";
import FavMovs from "../src/Pages/FavMovs";
import { GlobalProvider } from "./Context/GlobalState"
function App() {
  return (
    <GlobalProvider>
      <BrowserRouter>
        <Header />
        <div className="APP">
          <Container>
            <Switch>
              <Route path="/" component={Trending} exact />
              <Route path="/Movies" component={Movies} />
              <Route path="/series" component={Series} />
              <Route path="/search" component={Search} />
              <Route path="/FavMovs" component={FavMovs} />
            </Switch>
          </Container>
        </div>
        <SimpleBottomNavigation />
      </BrowserRouter>
    </GlobalProvider>
  );
}

export default App;
